import { Close } from "@mui/icons-material";
import { Modal } from "@mui/material";
import React from "react";
import Styles from "./ViewBids.module.css";
import { formatDateTimeView } from "../../../../commons/FormatDate";

const ViewBids = ({ open, handleClose, data }) => {
  console.debug(data);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.createEditModalCont}`}>
        <div className={`display_flex_row modalHeading ${Styles.headingText}`}>
          <div className={`headingText ${Styles.finalHead}`}>View Bid</div>
          <Close
            style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>
        <div className={Styles.modalDetials}>
          <div className={`display_flex_row tableHeading`}>
            <div style={{ width: "5%" }}>Sl.No</div>
            <div style={{ width: "20%" }}>Bid Quantity (MW)</div>
            <div style={{ width: "20%" }}>Bid Price ((₹/kWh))</div>
            <div style={{ width: "20%" }}>Last Activity</div>
          </div>
          <div className={`scroll_bar_y ${Styles.reqMainTableBody}`}>
            {!data && (
              <div className={`display_flex_row_center ${Styles.noBidElement}`}>
                No Bids Yet
              </div>
            )}
            {data?.map((ele, index) => (
              <div className={`display_flex_row tableDetails`}>
                <div style={{ width: "5%" }}>{index + 1}</div>
                <div style={{ width: "20%" }}>{ele?.bidQuantityMw}</div>
                <div style={{ width: "20%" }}>{ele?.bidPrice}</div>
                <div style={{ width: "20%" }}>
                  {formatDateTimeView(ele?.updatedAt)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewBids;
